import React from "react";
import LazyLoad from "vanilla-lazyload";
import "./lazyImg.less";

const lazyloadConfig = {
	elements_selector: ".lazy",
	// 加载中类名
	class_loading: "wowimg-lazy-loading",
	// 加载后类名
	class_loaded: "wowimg-lazy-loaded",
};

// Only initialize it one time for the entire application
if (typeof document !== "undefined" && !document.lazyLoadInstance) {
	document.lazyLoadInstance = new LazyLoad(lazyloadConfig);
}

export class LazyImage extends React.Component {
	// Update lazyLoad after first rendering of every image
	componentDidMount() {
		document.lazyLoadInstance.update();
	}

	// Update lazyLoad after rerendering of every image
	componentDidUpdate() {
		document.lazyLoadInstance.update();
	}
	// Just render the image with data-src
	render() {
		const { alt, src, srcset, sizes, width, height, coverAttrs} = this.props;
		return (
			<img
				alt={alt}
				className="lazy"
				data-src={src}
				data-srcset={srcset}
				data-sizes={sizes}
				width={width}
				height={height}
				onClick={this.props.onClick}
				{...coverAttrs}
			/>
		);
	}
}

export default LazyImage;
